function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#232F63;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#7BADC9;}\r\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#6197AA;}\r\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#9E2632;}\r\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#C1DEE8;}\r\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:#660E17;}\r\n\t.st7{fill-rule:evenodd;clip-rule:evenodd;fill:#F7931E;}\r\n\t.st8{fill:#FFFFFF;}\r\n\t.st9{font-family:'Roboto-Regular';}\r\n\t.st10{font-size:18px;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-1",
  className: "st0",
  points: "4.6,318.4 205.5,318.4 205.5,34 4.6,34 "
});

var _ref4 = /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-2",
  className: "st1",
  points: "0,315 200.9,315 200.9,30.5 0,30.5 "
});

var _ref5 = /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-5",
  className: "st2",
  points: "0.2,31 201.3,31 117.4,314.9 0.2,314.9 "
});

var _ref6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-7",
  className: "st3",
  points: "17.4,271.2 182,271.2 182,47.6 17.4,47.6  "
}));

var _ref7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-9",
  className: "st4",
  points: "49.5,58.4 151.2,58.4 151.2,26.8 49.5,26.8  "
}));

var _ref8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  id: "Fill-10",
  className: "st4",
  d: "M101.4,29.5c-6,0-10.8-4.9-10.8-10.8s4.8-10.9,10.8-10.9s10.8,4.9,10.8,10.9 S107.4,29.5,101.4,29.5 M101.4,0C91.1,0,82.7,8.4,82.7,18.7s8.4,18.7,18.7,18.7s18.7-8.4,18.7-18.7S111.7,0,101.4,0"
}));

var _ref9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-11",
  className: "st5",
  points: "41.9,163.2 157.2,163.2 157.2,156.5 41.9,156.5  "
}));

var _ref10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-12",
  className: "st5",
  points: "41.9,175 157.2,175 157.2,168.2 41.9,168.2  "
}));

var _ref11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-13",
  className: "st5",
  points: "41.9,190.4 157.2,190.4 157.2,183.7 41.9,183.7  "
}));

var _ref12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-14",
  className: "st5",
  points: "41.4,203.2 156.7,203.2 156.7,196.5 41.4,196.5  "
}));

var _ref13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-15",
  className: "st6",
  points: "49.5,58.4 151.2,58.4 151.2,45.1 49.5,45.1  "
}));

var _ref14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-44",
  className: "st7",
  points: "40,118.2 159.2,118.2 159.2,92.2 40,92.2  "
}));

var _ref15 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 47.03 111.77)",
  className: "st8 st9 st10"
}, "N");

var _ref16 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 60.19 111.77)",
  className: "st8 st9 st10"
}, "O");

var _ref17 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 73.47 111.77)",
  className: "st8 st9 st10"
}, "T SIGNED");

var _ref18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-14-2",
  className: "st0",
  points: "43.8,240.4 91.6,240.4 91.6,239.1 43.8,239.1  "
}));

var _ref19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-14-3",
  className: "st0",
  points: "110.4,240.1 158.2,240.1 158.2,238.8 110.4,238.8  "
}));

const SvgNominationNotSignedIllustration = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 205.5 318.4",
    style: {
      enableBackground: "new 0 0 205.5 318.4"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNominationNotSignedIllustration, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Nomination_not_signed_Illustration.36d0c7bd.svg";
export { ForwardRef as ReactComponent };